<template>
    <label :for="id" class="checkbox__label" @click.stop>
    <input type="checkbox"
           v-model="checked"
           :id="id"
           :value="val"
           @change="handleChange"
           class="checkbox__input"
           :name="name"
    />
    <span class="checkbox__checkmark"></span>
    </label>
</template>

<script>
    export default {
        name: 'totem-checkbox',
        props: {
            value: {},
            val: {},
            label: {},
            id: {},
            name: String
        },
        data () {
            return {
                checkedProxy: false
            }
        },
        computed: {
            checked: {
                get () {
                    return this.value
                },
                set (val) {
                    this.checkedProxy = val
                }
            }
        },
        methods: {
            handleChange (e) {
                this.$emit('input', this.checkedProxy)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .checkbox {
        &__label {
            display: block;
            position: relative;
            cursor: pointer;
            font-size: 2.2rem;
            margin: 0 20px 0 0;
            user-select: none;
            z-index: 1;
        }

        &__input {
            opacity: 0;
            cursor: pointer;
        }

        &__checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 28px;
            width: 28px;
            background: $white;
            border: 1px solid $quill_gray;
            border-radius: 4px;
        }

        &__label:hover input ~ .checkbox__checkmark {
            background: $alabaster;
            border-color: $manatee;
        }

        &__label input:checked ~ .checkbox__checkmark:after {
            display: block;
        }

        &__label .checkbox__checkmark:after {
            content: "x";
            position: absolute;
            display: none;
            left: 6px;
            top: -8px;
            font-size: 3rem;
            color: $black;
        }
    }
</style>
